// extracted by mini-css-extract-plugin
export var content = "FlyoverUpsell-module__content___eYpai";
export var logo = "FlyoverUpsell-module__logo___T2hFs";
export var feature = "FlyoverUpsell-module__feature___S418j";
export var features = "FlyoverUpsell-module__features___kNqNo";
export var title = "FlyoverUpsell-module__title___KNkFr";
export var header = "FlyoverUpsell-module__header___mFy0G";
export var close = "FlyoverUpsell-module__close___ya7OX";